import { render } from "./AppRouter.vue?vue&type=template&id=39157e90&scoped=true&ts=true"
import script from "./AppRouter.vue?vue&type=script&lang=ts"
export * from "./AppRouter.vue?vue&type=script&lang=ts"

import "./AppRouter.vue?vue&type=style&index=0&id=39157e90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39157e90"]])

export default __exports__